export const LOG_CONVERSION = "LOG_CONVERSION";

export const logConversion = (payload) => ({
    type: LOG_CONVERSION,
    payload: payload,
});
